import { httpClient } from "@/libs/http";
import { httpNoLoading } from "@/libs/httpNoLoading";
import {
    ORDER_RENEWAL_DEFAULT_DATA,
    IDENTIFICATION_DOCUMENT_NAME,
    ORDER_STATUS,
} from "@/libs/const";

export default {
    data: () => ({
        order: {},
        renewal: { ...ORDER_RENEWAL_DEFAULT_DATA },
        services: [],
        vouchers: [],
        code: null,
        step: 1,
        isLoading: false,
        orderDialog: false,
        uploadDialog: false,
        documentName: { ...IDENTIFICATION_DOCUMENT_NAME },
        orderInterval: 0
    }),
    computed: {
        scannedCodes() {
            return [];
        },

        voucherOptions() {
            if (!this.vouchers || this.vouchers.length === 0) {
                return [];
            }

            return [...this.vouchers]
                .filter((voucher) => voucher.id_country == this.order.id_country)
                .map((voucher) => ({
                    text: `${voucher.code} - ${voucher.name}`,
                    value: voucher.id,
                }));
        },
    },
    watch: {},
    mounted() {
        this.getVouchers();
        this.listenSocket();

        this.orderInterval = setInterval(() => {
            this.reCheckOrder();
        }, 5000);
    },
    beforeDestroy() {
        clearInterval(this.orderInterval);
        this.orderInterval = 0;
    },
    methods: {
        onReset() {
            if (this.renewal.id) {
                httpClient.post("/order/v1/cancel-processing", {
                    id_order: this.renewal.id,
                });
            }

            this.renewal = { ...ORDER_RENEWAL_DEFAULT_DATA };
            this.order = {};
            this.step = 1;
        },

        pageReload() {
            window.location.reload();
        },

        nextStep() {
            this.step++;
        },

        goBack() {
            this.step--;
        },

        printContract() {
            if (!this.isMobileAgent()) {
                this.downloadPdfServerFilename("/order/v1/generate-contract", {
                    id_order: this.renewal.id,
                    id_branch: this.renewal.id_branch,
                    id_account: window.me.id,
                });
            } else {
                httpClient.post("/order/v1/mobile-call-generate-contract", {
                    id_order: this.renewal.id,
                    id_branch: this.renewal.id_branch,
                    id_account: window.me.id,
                    print_url: "/order/v1/generate-contract",
                });
            }
        },

        async reCheckOrder() {
            if (!this.renewal || !this.renewal.id || this.step != 2) {
                return false;
            }

            const { data } = await httpNoLoading.post("/order/v1/get-detail", {
                id_order: this.renewal.id,
            });

            if (data.status == ORDER_STATUS.WAIT_RENEWAL) {
                this.step = 3;
                this.printContract()
            }
        },

        listenSocket() {
            window.socket.on("order_paid", (data) => {
                console.log("listenSocket->data", data);

                const { id_order } = data;

                if (id_order == this.renewal.id && this.step == 2) {
                    this.step = 3;
                    this.printContract()
                }
            });
        },

        async getVouchers() {
            const { data } = await httpClient.post("/common/v1/get-active-voucher");
            this.vouchers = [...data];
        },

        async saveAndNext() {
            try {
                const { data } = await httpClient.post(
                    "/order/v1/renewal-save-processing",
                    {
                        id_order: this.order.id,
                        ...this.renewal,
                    }
                );
                this.renewal = { ...this.renewal, ...data };

                this.nextStep();
            } catch (e) {
                const errMsg =
                    (e.response &&
                        e.response.data &&
                        e.response.data.error &&
                        e.response.data.error.message) ||
                    null;
                this.$vToastify.error(errMsg);
            }
        },

        async getProcessing() {
            const { data } = await httpClient.post("/order/v1/renewal-processing");
            if (data && data.id) {
                const renewal = {
                    id: data.id,
                    id_branch: data.id_branch,
                    rent_day: data.rent_day,
                    rent_hour: data.rent_hour,
                    id_voucher: data.id_voucher,
                };
                this.renewal = { ...renewal };

                const order = await httpClient.post("/order/v1/get-detail", {
                    id_order: data.id_order_parent,
                });

                if (order && order.data) {
                    this.order = { ...order.data };
                }
            }
        },

        async scanInput() {
            if (!this.code) {
                return false;
            }

            const code = this.code.toUpperCase();

            if (this.scannedCodes.includes(code)) {
                this.code = null;
                document.getElementById("error_sound_player").play();
                this.$vToastify.error(this.$t("Mã đã quét"));
                return false;
            }

            if (this.isLoading) {
                this.$vToastify.warning(this.$t("Loading"));
                return false;
            }

            this.isLoading = true;

            try {
                const { data } = await httpClient.post(
                    "/order/v1/renewal-get-order-by-code",
                    {
                        code: code,
                    }
                );
                this.code = null;
                this.isLoading = false;

                this.order = { ...data };

                document.getElementById("success_sound_player").play();
            } catch (e) {
                const errMsg =
                    (e.response &&
                        e.response.data &&
                        e.response.data.error &&
                        e.response.data.error.message) ||
                    null;
                this.$vToastify.error(errMsg);
                this.code = null;
                this.isLoading = false;
                document.getElementById("error_sound_player").play();
            }
        },
    },
}